import React, { useState } from 'react'

type Props = {
    isOpen: boolean
    isHover: boolean
    onClick: () => void
}

const CloseIcon: React.FC<{ isOpen: boolean; isHover: boolean }> = ({
    isOpen,
    isHover,
}) => {
    return (
        <svg
            className={`absolute top-0 left-0 w-5 h-5 duration-300 transform transition-all ${isOpen ? 'opacity-100 scale-[1]' : 'opacity-0 scale-[0]'}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            id="times"
        >
            <path
                fill="#fff"
                d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
            ></path>
        </svg>
    )
}

const HamburgerIcon: React.FC<{ isOpen: boolean; isHover: boolean }> = ({
    isOpen,
    isHover,
}) => {
    return (
        <svg
            className={`absolute top-0 left-0 w-5 h-5 duration-300 transform transition-all ${isHover ? 'text-white' : 'text-[#407bff]'}  ${isOpen ? 'opacity-0 scale-[0]' : 'opacity-100 scale-[1]'}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            id="bars"
        >
            <path
                fill="currentColor"
                d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
            ></path>
        </svg>
    )
}

export const MenuHamburger: React.FC<Props> = (props) => {
    const active = props.isOpen || props.isHover

    return (
        <div
            className={`flex flex-row h-8 w-fit px-2 gap-1 items-center justify-center
        duration-300 transition-all rounded-[10px] text-[12.8px]
        border-2 border-[#407bff] cursor-pointer
        ${active ? 'bg-[#407bff] text-white' : 'bg-transparent text-[#181818]'}
      `}
            onClick={(e) => {
                e.stopPropagation()
                props.onClick()
            }}
        >
            Меню
            <div className="relative w-5 h-5">
                <CloseIcon isOpen={props.isOpen} isHover={props.isHover} />
                <HamburgerIcon isOpen={props.isOpen} isHover={active} />
            </div>
        </div>
    )
}
